import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';

interface DonateButtonProps {
  className?: string;
  size?: 'sm' | 'md';
  donateUrl?: string;
}

export const DonateButton: React.FC<DonateButtonProps> = ({
  className = '',
  size = 'md',
  donateUrl = '/donate'
}) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  // Base styles
  const baseStyles = `
    shrink-0 inline-flex items-center justify-center gap-2 
    rounded-full font-medium
    text-white
    transition-all duration-300
    hover:-translate-y-0.5
    hover:shadow-lg active:shadow-md active:translate-y-0
    focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500
    group relative overflow-hidden
  `;
  
  // Size styles
  const sizeStyles = {
    sm: "h-8 px-3 py-1 text-sm",
    md: "h-10 px-4 py-2 text-sm"
  };

  // Icon sizes
  const iconSizes = {
    sm: "w-3.5 h-3.5",
    md: "w-4 h-4"
  };

  // Gradient styles
  const gradientStyle = {
    background: isHovered
      ? "linear-gradient(to right, rgba(var(--colors-primary-500-rgb), 0.95), rgba(var(--colors-primary-500-rgb), 1))"
      : "linear-gradient(to right, rgba(var(--colors-primary-500-rgb), 0.85), rgba(var(--colors-primary-500-rgb), 0.95))"
  };

  return (
    <button 
      onClick={() => window.open(donateUrl, '_blank')}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`
        ${baseStyles}
        ${sizeStyles[size]}
        ${className}
      `}
      style={gradientStyle}
    >
      <Icon 
        icon="ph:hand-heart-thin"
        className={`${iconSizes[size]} transition-transform group-hover:scale-110`}
      />
      <span>{t('navigation.donate')}</span>
    </button>
  );
};

export default DonateButton; 